import create from 'zustand';
import {
    persist, devtools
} from "zustand/middleware"

let store = (set) => ({
    token: null,
    authenticated: false,
    user: {},
    setAuth: (payload) => set(state => ({
        ...payload
    })),
    clearAuth: () => set(state => ({
        token: null,
        authenticated: false,
        user: { },
    }))
});


store = persist(store, {
    name: "ur-auth"
})

store = devtools(store);

let authStore = create(store);

export default authStore;